import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import PushNotificationScreen from "@/screens/Settings/Troubleshooting/PushNotificationScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  return <PushNotificationScreen {...props} />;
}

export default withSessionHandling(Page);
